<template>
  <v-dialog
    value="true"
    :max-width="maxWidth"
    :persistent="persistent"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title
        :class="`title font-weight-bold ${color}--text`"
        v-if="title"
      >
        <v-icon size="28" :class="`mr-2 ${color}--text`">info</v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text :class="{ 'pt-4': !title }">{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="btnOkColor" text @click="close">{{ btnOkText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    btnOkText: {
      type: String,
      default: 'Ok'
    },
    btnOkColor: {
      type: String,
      default: 'primary'
    },
    color: {
      type: String,
      default: 'error'
    },
    message: {
      type: String,
      required: true
    },
    persistent: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    maxWidth: {
      type: Number,
      default: 400
    }
  },
  methods: {
    close () {
      this.$emit('close')
      this.$destroy()
    }
  }
}
</script>
